export default {
  postMedia(data) {
    return this.post('/oauth/media', data, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};
